export default __webpack_public_path__ + "static/kycchain-b9faf62b0b14b5e251f914425cc8f6b3.jpg";